import script from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"
export * from "./Dashboard.vue?vue&type=script&lang=ts&setup=true"

import "./Dashboard.vue?vue&type=style&index=0&id=678748a9&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=678748a9&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-678748a9"]])

export default __exports__